import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-foreground-300">
      <div className="px-6 md:px-12 lg:px-20 py-16 md:py-20">
        <div className="max-w-[1280px] mx-auto">
          {/* Main Footer Content */}
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
            {/* Left - Brand + Info */}
            <div className="md:col-span-5 space-y-6">
              <Link to="/" className="flex items-center gap-3 group cursor-pointer">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-lg bg-primary-800 flex items-center justify-center transition-all duration-300 group-hover:bg-primary-700">
                  <span className="text-accent-500 font-bold text-sm md:text-base tracking-widest font-heading">BC</span>
                </div>
                <div className="flex flex-col leading-tight">
                  <span className="text-xs md:text-sm text-foreground-100 tracking-[0.15em] font-sans font-light">BANKCARD CHECK</span>
                  <span className="text-[10px] md:text-[11px] text-foreground-400 tracking-[0.1em] font-sans font-light">株式会社バンクカード・チェック</span>
                </div>
              </Link>
              <address className="not-italic space-y-2 text-xs md:text-sm tracking-[0.05em] leading-relaxed">
                <p>〒100-0005 東京都千代田区丸の内1丁目5-1</p>
                <p>新丸の内ビルディング 12F</p>
                <p className="pt-2">
                  <span className="text-foreground-500">TEL:</span>{' '}
                  <a href="tel:0352158420" className="hover:text-accent-400 transition-colors cursor-pointer">03-5215-8420</a>
                </p>
                <p>
                  <span className="text-foreground-500">Email:</span>{' '}
                  <a href="mailto:admin@bankcard-chcak.jp" className="hover:text-accent-400 transition-colors cursor-pointer">admin@bankcard-chcak.jp</a>
                </p>
                <p className="pt-2">
                  <span className="text-foreground-500">代表取締役社長:</span>{' '}
                  <span className="text-foreground-200">佐藤 健一</span>
                </p>
              </address>
            </div>

            {/* Right - Nav Columns */}
            <div className="md:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
              <div className="space-y-3">
                <h4 className="text-xs tracking-[0.12em] text-foreground-100 font-sans font-medium mb-4">企業情報</h4>
                <Link to="/" className="block text-xs md:text-sm text-foreground-400 hover:text-accent-400 transition-colors tracking-[0.05em] cursor-pointer">会社概要</Link>
                <Link to="/services" className="block text-xs md:text-sm text-foreground-400 hover:text-accent-400 transition-colors tracking-[0.05em] cursor-pointer">事業紹介</Link>
                <Link to="/contact" className="block text-xs md:text-sm text-foreground-400 hover:text-accent-400 transition-colors tracking-[0.05em] cursor-pointer">お問合わせ</Link>
              </div>
              <div className="space-y-3">
                <h4 className="text-xs tracking-[0.12em] text-foreground-100 font-sans font-medium mb-4">サービス</h4>
                <a href="/services#solutions" className="block text-xs md:text-sm text-foreground-400 hover:text-accent-400 transition-colors tracking-[0.05em] cursor-pointer">ソリューション</a>
                <a href="/services#results" className="block text-xs md:text-sm text-foreground-400 hover:text-accent-400 transition-colors tracking-[0.05em] cursor-pointer">導入効果</a>
                <a href="/contact" className="block text-xs md:text-sm text-foreground-400 hover:text-accent-400 transition-colors tracking-[0.05em] cursor-pointer">資料請求</a>
              </div>
              <div className="space-y-3">
                <h4 className="text-xs tracking-[0.12em] text-foreground-100 font-sans font-medium mb-4">法務情報</h4>
                <Link to="/privacy" className="block text-xs md:text-sm text-foreground-400 hover:text-accent-400 transition-colors tracking-[0.05em] cursor-pointer">プライバシーポリシー</Link>
                <Link to="/terms" className="block text-xs md:text-sm text-foreground-400 hover:text-accent-400 transition-colors tracking-[0.05em] cursor-pointer">利用規約</Link>
                <Link to="/cookie" className="block text-xs md:text-sm text-foreground-400 hover:text-accent-400 transition-colors tracking-[0.05em] cursor-pointer">Cookieポリシー</Link>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="mt-14 pt-8 border-t border-foreground-800/40 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <p className="text-[11px] md:text-xs text-foreground-500 tracking-[0.05em]">
              &copy; {new Date().getFullYear()} BankCard Check Co., Ltd. All Rights Reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link to="/privacy" className="text-[11px] md:text-xs text-foreground-500 hover:text-accent-400 transition-colors tracking-[0.05em] cursor-pointer">プライバシー</Link>
              <span className="text-foreground-700">|</span>
              <Link to="/terms" className="text-[11px] md:text-xs text-foreground-500 hover:text-accent-400 transition-colors tracking-[0.05em] cursor-pointer">利用規約</Link>
              <span className="text-foreground-700">|</span>
              <Link to="/cookie" className="text-[11px] md:text-xs text-foreground-500 hover:text-accent-400 transition-colors tracking-[0.05em] cursor-pointer">Cookie</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}